import type { MisconceptionDefinition } from '../types';
export const STU_SCHEMAS_MISCONCEPTIONS: MisconceptionDefinition[] = [
// ───────────────────────────────────────────────────────────
// STU-FLOWCHART — procesflowchart lezen
// ───────────────────────────────────────────────────────────
{
  id: 'stu.flowchart-ruit-rechthoek-verward',
  label: 'Ruit en rechthoek verward',
  module: 'Studievaardig',
  description: 'Leerling verwart een ruit (beslissing) met een rechthoek (actie).',
  typicalFamilies: ['STU-FLOWCHART']
}, {
  id: 'stu.flowchart-ruit-start-verward',
  label: 'Ruit en begin verward',
  module: 'Studievaardig',
  description: 'Leerling verwart een ruit (beslissing) met een ovaal (start).',
  typicalFamilies: ['STU-FLOWCHART']
}, {
  id: 'stu.flowchart-ruit-einde-verward',
  label: 'Ruit en einde verward',
  module: 'Studievaardig',
  description: 'Leerling verwart een ruit (beslissing) met een ovaal (eind).',
  typicalFamilies: ['STU-FLOWCHART']
}, {
  id: 'stu.flowchart-beide-paden-gevolgd',
  label: 'Beide paden tegelijk gevolgd',
  module: 'Studievaardig',
  description: 'Leerling volgt beide ja/nee-paden uit een beslissingsruit i.p.v. te kiezen.',
  typicalFamilies: ['STU-FLOWCHART']
}, {
  id: 'stu.flowchart-loop-verondersteld',
  label: 'Niet-bestaande loop verondersteld',
  module: 'Studievaardig',
  description: 'Leerling veronderstelt dat het proces terugkeert terwijl er geen terugpijl in de flowchart staat.',
  typicalFamilies: ['STU-FLOWCHART']
}, {
  id: 'stu.flowchart-beslissing-als-einde',
  label: 'Beslissingsruit gezien als einde',
  module: 'Studievaardig',
  description: 'Leerling denkt dat het proces stopt bij een beslissingsruit i.p.v. dat er verder wordt gegaan langs ja/nee-pijl.',
  typicalFamilies: ['STU-FLOWCHART']
}, {
  id: 'stu.flowchart-staafdiagram-verward',
  label: 'Flowchart en staafdiagram verward',
  module: 'Studievaardig',
  description: 'Leerling kent de procesfunctie van een flowchart niet en verwart het met een staafdiagram.',
  typicalFamilies: ['STU-FLOWCHART']
}, {
  id: 'stu.flowchart-cirkeldiagram-verward',
  label: 'Flowchart en cirkeldiagram verward',
  module: 'Studievaardig',
  description: 'Leerling verwart een flowchart met een cirkeldiagram (deel-van-geheel).',
  typicalFamilies: ['STU-FLOWCHART']
}, {
  id: 'stu.flowchart-lijndiagram-verward',
  label: 'Flowchart en lijndiagram verward',
  module: 'Studievaardig',
  description: 'Leerling verwart een flowchart met een lijndiagram (verloop over tijd).',
  typicalFamilies: ['STU-FLOWCHART']
}, {
  id: 'stu.flowchart-terugpijl-als-fout',
  label: 'Terugpijl gezien als fout',
  module: 'Studievaardig',
  description: 'Leerling interpreteert een terugpijl (loop) als tekening-fout i.p.v. bewuste herhaling.',
  typicalFamilies: ['STU-FLOWCHART']
}, {
  id: 'stu.flowchart-loop-herstart-alles',
  label: 'Loop herstart hele proces',
  module: 'Studievaardig',
  description: 'Leerling denkt dat een terugpijl het hele proces opnieuw start i.p.v. alleen de loop-stap herhaalt.',
  typicalFamilies: ['STU-FLOWCHART']
}, {
  id: 'stu.flowchart-loop-als-einde',
  label: 'Loop als einde gezien',
  module: 'Studievaardig',
  description: 'Leerling denkt dat een terugpijl markeert dat het proces eindigt.',
  typicalFamilies: ['STU-FLOWCHART']
},
// ───────────────────────────────────────────────────────────
// STU-MINDMAP — mindmap-structuur
// ───────────────────────────────────────────────────────────
{
  id: 'stu.mindmap-details-in-midden',
  label: 'Details in het midden',
  module: 'Studievaardig',
  description: 'Leerling plaatst details in het centrum i.p.v. het hoofdonderwerp.',
  typicalFamilies: ['STU-MINDMAP']
}, {
  id: 'stu.mindmap-conclusie-in-midden',
  label: 'Conclusie in het midden',
  module: 'Studievaardig',
  description: 'Leerling verwart mindmap-centrum met de conclusie van een samenvatting.',
  typicalFamilies: ['STU-MINDMAP']
}, {
  id: 'stu.mindmap-bronnen-in-midden',
  label: 'Bronnenlijst in het midden',
  module: 'Studievaardig',
  description: 'Leerling verwart het centrum van een mindmap met een bronnen- of literatuurlijst.',
  typicalFamilies: ['STU-MINDMAP']
}, {
  id: 'stu.mindmap-kleur-als-decoratie',
  label: 'Kleur als decoratie gezien',
  module: 'Studievaardig',
  description: 'Leerling ziet kleuren in een mindmap als versiering i.p.v. als informatie-grouperende code.',
  typicalFamilies: ['STU-MINDMAP']
}, {
  id: 'stu.mindmap-kleur-verplicht',
  label: 'Kleur verplicht geacht',
  module: 'Studievaardig',
  description: 'Leerling denkt dat een mindmap niet correct is zonder kleur, terwijl kleur optioneel-functioneel is.',
  typicalFamilies: ['STU-MINDMAP']
}, {
  id: 'stu.mindmap-kleur-meer-tekst',
  label: 'Kleur verward met tekstcapaciteit',
  module: 'Studievaardig',
  description: 'Leerling denkt dat een gekleurde tak meer tekst kan dragen dan een ongekleurde.',
  typicalFamilies: ['STU-MINDMAP']
}, {
  id: 'stu.mindmap-hele-zinnen-op-takken',
  label: 'Hele zinnen op takken',
  module: 'Studievaardig',
  description: 'Leerling schrijft hele zinnen op mindmap-takken i.p.v. kernwoorden.',
  typicalFamilies: ['STU-MINDMAP', 'STU-NOTITIES']
}, {
  id: 'stu.mindmap-paginanummers',
  label: 'Mindmap met paginanummers',
  module: 'Studievaardig',
  description: 'Leerling verwart mindmap (begrip-relaties) met inhoudsopgave (paginanummers).',
  typicalFamilies: ['STU-MINDMAP']
}, {
  id: 'stu.mindmap-vragen-als-takken',
  label: 'Vragen als takken',
  module: 'Studievaardig',
  description: 'Leerling verwart mindmap-structuur met een vragenstrategie (KWL — Know/Want/Learned).',
  typicalFamilies: ['STU-MINDMAP']
},
// ───────────────────────────────────────────────────────────
// STU-KAART — schaal en legenda
// ───────────────────────────────────────────────────────────
{
  id: 'stu.kaart-alleen-1cm-vermenigvuldigd',
  label: 'Alleen 1 cm vermenigvuldigd',
  module: 'Studievaardig',
  description: 'Leerling vermenigvuldigt de schaal met 1 in plaats van met de gemeten afstand.',
  typicalFamilies: ['STU-KAART']
}, {
  id: 'stu.kaart-cm-naar-meter-fout',
  label: 'Fout bij cm naar meter',
  module: 'Studievaardig',
  description: 'Leerling maakt een fout bij het omrekenen van centimeters naar meters.',
  typicalFamilies: ['STU-KAART']
}, {
  id: 'stu.kaart-schaal-delen-ipv-vermenigvuldigen',
  label: 'Deelt door schaal i.p.v. vermenigvuldigen',
  module: 'Studievaardig',
  description: 'Leerling deelt de afstand op de kaart door de schaal in plaats van te vermenigvuldigen.',
  typicalFamilies: ['STU-KAART']
}, {
  id: 'stu.kaart-eenheid-verward',
  label: 'Eenheid verward',
  module: 'Studievaardig',
  description: 'Leerling verwart de eenheden (cm, m, km) bij het werken met schaal.',
  typicalFamilies: ['STU-KAART']
}, {
  id: 'stu.kaart-eenheid-km-vergeten',
  label: 'Vergeet om te rekenen naar km',
  module: 'Studievaardig',
  description: 'Leerling geeft het antwoord in cm of m in plaats van km.',
  typicalFamilies: ['STU-KAART']
}, {
  id: 'stu.kaart-nullen-tellen-fout',
  label: 'Fout bij nullen tellen',
  module: 'Studievaardig',
  description: 'Leerling telt het verkeerde aantal nullen bij het omrekenen.',
  typicalFamilies: ['STU-KAART']
}, {
  id: 'stu.kaart-cm-gelijk-aan-km',
  label: 'Stelt cm gelijk aan km',
  module: 'Studievaardig',
  description: 'Leerling denkt dat de waarde in cm direct de waarde in km is.',
  typicalFamilies: ['STU-KAART']
}, {
  id: 'stu.kaart-legenda-kleur-assoc-bos',
  label: 'Kleur-associatie bos i.p.v. legenda',
  module: 'Studievaardig',
  description: 'Leerling associeert een kleur (bruin/groen) met bos in plaats van de legenda te raadplegen.',
  typicalFamilies: ['STU-KAART']
}, {
  id: 'stu.kaart-legenda-kleur-assoc-water',
  label: 'Kleur-associatie water i.p.v. legenda',
  module: 'Studievaardig',
  description: 'Leerling verwart kleurassociaties (bv. bruin met water) i.p.v. de legenda te gebruiken.',
  typicalFamilies: ['STU-KAART']
}, {
  id: 'stu.kaart-legenda-aanname-zonder-kijken',
  label: 'Aanname zonder legenda te raadplegen',
  module: 'Studievaardig',
  description: 'Leerling verzint de betekenis van een symbool of kleur zonder de legenda te lezen.',
  typicalFamilies: ['STU-KAART']
}, {
  id: 'stu.kaart-legenda-onvolledig-wandel',
  label: 'Legenda onvolledig gelezen (wandel)',
  module: 'Studievaardig',
  description: 'Leerling leest de legenda onvolledig en sluit alleen het wandelpad uit.',
  typicalFamilies: ['STU-KAART']
}, {
  id: 'stu.kaart-legenda-onvolledig-fiets',
  label: 'Legenda onvolledig gelezen (fiets)',
  module: 'Studievaardig',
  description: 'Leerling leest de legenda onvolledig en sluit alleen het fietspad uit.',
  typicalFamilies: ['STU-KAART']
}, {
  id: 'stu.kaart-legenda-symbool-onderscheid-gemist',
  label: 'Symbool-onderscheid in legenda gemist',
  module: 'Studievaardig',
  description: 'Leerling mist het onderscheid tussen verschillende padtypen of symbolen in de legenda.',
  typicalFamilies: ['STU-KAART']
},
// ───────────────────────────────────────────────────────────
// STU-ROUTE — routes lezen en plannen
// ───────────────────────────────────────────────────────────
{
  id: 'stu.route-afslagen-gemist',
  label: 'Afslagen gemist',
  module: 'Studievaardig',
  description: 'Leerling mist een of meerdere afslagen in een routebeschrijving.',
  typicalFamilies: ['STU-ROUTE']
}, {
  id: 'stu.route-locatie-als-afslag',
  label: 'Locatie als afslag gezien',
  module: 'Studievaardig',
  description: 'Leerling ziet een locatie-aanduiding (zoals "aan je linkerhand") als een afslag.',
  typicalFamilies: ['STU-ROUTE']
}, {
  id: 'stu.route-rechtdoor-verondersteld',
  label: 'Rechtdoor verondersteld',
  module: 'Studievaardig',
  description: 'Leerling veronderstelt ten onrechte dat de route rechtdoor gaat.',
  typicalFamilies: ['STU-ROUTE']
}, {
  id: 'stu.route-symbool-snelweg-verward',
  label: 'Snelweg symbool verward',
  module: 'Studievaardig',
  description: 'Leerling verwart het symbool voor een fietspad met dat van een snelweg.',
  typicalFamilies: ['STU-ROUTE']
}, {
  id: 'stu.route-symbool-water-verward',
  label: 'Water symbool verward',
  module: 'Studievaardig',
  description: 'Leerling verwart het symbool voor een fietspad met dat van water.',
  typicalFamilies: ['STU-ROUTE']
}, {
  id: 'stu.route-symbool-natuur-verward',
  label: 'Natuur symbool verward',
  module: 'Studievaardig',
  description: 'Leerling verwart het symbool voor een fietspad met dat van natuur.',
  typicalFamilies: ['STU-ROUTE']
}, {
  id: 'stu.route-veiligheid-genegeerd',
  label: 'Veiligheid genegeerd',
  module: 'Studievaardig',
  description: 'Leerling kiest de kortste route en negeert de veiligheid.',
  typicalFamilies: ['STU-ROUTE']
}, {
  id: 'stu.route-veiligheid-gelijkgesteld',
  label: 'Veiligheid gelijkgesteld',
  module: 'Studievaardig',
  description: 'Leerling denkt dat alle routes even veilig zijn.',
  typicalFamilies: ['STU-ROUTE']
}, {
  id: 'stu.route-veiligheid-ontkend',
  label: 'Veiligheid ontkend',
  module: 'Studievaardig',
  description: 'Leerling denkt dat geen enkele route veilig is.',
  typicalFamilies: ['STU-ROUTE']
}, {
  id: 'stu.route-eerste-weg-gekozen',
  label: 'Eerste weg gekozen zonder vergelijking',
  module: 'Studievaardig',
  description: 'Leerling neemt meteen de eerste route die hij ziet, zonder routes te vergelijken.',
  typicalFamilies: ['STU-ROUTE']
}, {
  id: 'stu.route-vriend-als-planner',
  label: 'Vriend gevraagd i.p.v. zelf plannen',
  module: 'Studievaardig',
  description: 'Leerling laat een vriend de route plannen in plaats van zelf de kaart te lezen.',
  typicalFamilies: ['STU-ROUTE']
}, {
  id: 'stu.route-langste-weg-gekozen',
  label: 'Langste route gekozen i.p.v. kortste',
  module: 'Studievaardig',
  description: 'Leerling kiest de langste route terwijl de kortste gevraagd was — vraag niet goed gelezen.',
  typicalFamilies: ['STU-ROUTE']
}];